import React, { PropsWithChildren } from "react";

interface SplitterProps extends React.HTMLAttributes<HTMLDivElement> {
  layout?: "horizontal" | "vertical";
}

interface PanelProps extends React.HTMLAttributes<HTMLDivElement> {
  defaultSize?: string | number;
  min?: string | number;
  max?: string | number;
  collapsible?: boolean;
}

export const Splitter = ({ layout = "horizontal", style, children, ...rest }: PropsWithChildren<SplitterProps>) => {
  const direction = layout === "vertical" ? "column" : "row";
  return (
    <div style={{ display: "flex", flexDirection: direction, width: "100%", height: "100%", ...style }} {...rest}>
      {children}
    </div>
  );
};

const Panel = ({ defaultSize, style, children, ...rest }: PropsWithChildren<PanelProps>) => {
  const basis =
    defaultSize === undefined ? undefined : typeof defaultSize === "number" ? `${defaultSize}px` : defaultSize;
  return (
    <div style={{ flex: basis ? `0 0 ${basis}` : "1 1 0%", minWidth: 0, minHeight: 0, ...style }} {...rest}>
      {children}
    </div>
  );
};

// Attach as static property for API parity
Splitter.Panel = Panel;

export default Splitter;
